module.exports = __webpack_public_path__ + "fonts/agenda_regular.ttf";